export default "__VITE_ASSET__fmeSyfpS__"